// extracted by mini-css-extract-plugin
export default {"container":"tab_container__blrXl","tabs":"tab_tabs__geK8w","tab":"tab_tab__cXwOK"};